import React from "react"
import styled from "styled-components"

const TooltipEl = styled.div`
  background: ${({ theme }) => theme.spaceblue};
  border-radius: 4px;
  color: ${({ theme }) => theme.white};
  font-size: 13px;
  font-weight: 700;
  max-width: 210px;
  padding: 15px;
  z-index: 1;

  .arrow {
    height: 10px;
    position: absolute;
    width: 10px;

    &:after {
      background-color: ${({ theme }) => theme.spaceblue};
      content: " ";
      height: 10px;
      left: 0;
      position: absolute;
      transform: rotate(45deg);
      width: 10px;
    }
  }

  &[data-popper-placement^="top"] > .arrow {
    bottom: -5px;
  }

  &[data-popper-placement^="bottom"] > .arrow {
    top: -5px;
  }
`

const Tooltip = ({
  text,
  forwardRef,
  styles,
  attributes,
  arrowRef,
  ...props
}) => {
  return (
    <TooltipEl ref={forwardRef} style={styles.popper} {...props}>
      {text}
      <div ref={arrowRef} style={styles.arrow} className="arrow" />
    </TooltipEl>
  )
}

export default Tooltip
